import { render, staticRenderFns } from "./CartGift.vue?vue&type=template&id=634dcf00&"
import script from "./CartGift.vue?vue&type=script&lang=js&"
export * from "./CartGift.vue?vue&type=script&lang=js&"
import style0 from "./CartGift.vue?vue&type=style&index=0&id=634dcf00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports